import React, { Fragment } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { FormattedMessage } from 'react-intl';

const KrissyThankYou = ({styles}) => (
    <div className="thank-you thank-you-grace">{``}
        <div className="mainDesktop__container">
            <div>
                <img className="grace-logo" src="https://toneandsculpt.app/wp-content/uploads/2019/02/logo.png" alt=""/>
            </div>
            <hr />
            <div><h1>Thank you!</h1></div>
            <p><strong>Your payment has been processed successfully</strong>
                <img className="check-box-small" src="https://s3.eu-west-2.amazonaws.com/assets.aflete.com/checkout/checkbox.png" alt=""/>
            </p>
            <p>
                You will receive an order confirmation email with all the details and download links for any Guide’s included in your order.
            </p>
            <p>
                Please, check your spam or junk folders if it's not in your inbox.
            </p>
            <h3>Support</h3>
            <p>For any problems please contact our support</p>
            <a href="https://support.toneandsculpt.app/hc/en-us" target="_blank">
                <RaisedButton
                    type="submit"
                    label="SUPPORT CENTER"
                    style={styles.button}
                    primary
                />
            </a>
            <br />
            <br />
        </div>
    </div>   
);

export default KrissyThankYou;